import Bubbles from './Bubbles';

export default Bubbles;
